import rootSaga from '../sagas';
import production from './configureStore.dev';
import development from './configureStore.prod';

const configureStore = process.env.NODE_ENV === 'production' ? development : production;

const initialState = {};
const store = configureStore(initialState);

export const sagaTask = store.runSaga(rootSaga);
export default store;
